import React from 'react';

function TestimonialsItem({ testimonialText, shouldShowIconInSlide }) {
  return (
    <div className="mn_testimonialsItem">
      {shouldShowIconInSlide && <div className="mn_testimonialsIcon" />}
      <p className="mn_testimonialsText"><span>{testimonialText}</span></p>
    </div>
  );
}

export default TestimonialsItem;
